<ng-container [ngSwitch]="capacityStatus">
  <mat-chip-list>
    <mat-chip
      size="sm"
      class="appliance-chip-stats"
      [ngClass]="{
        oversubscribed: capacityStatus === APPLIANCE_CAPACITY_STATUS.Oversubscribed,
        healthy: capacityStatus === APPLIANCE_CAPACITY_STATUS.Healthy,
        unknown: capacityStatus === APPLIANCE_CAPACITY_STATUS.Unknown,
        pending: capacityStatus === APPLIANCE_CAPACITY_STATUS.UpdatesPending
      }"
    >
      <!-- HEALTHY -->
      <div *ngSwitchCase="APPLIANCE_CAPACITY_STATUS.Healthy" class="healthy-appliance-chip-label">
        <span>{{ 'appliances.capacity.healthy' | t }}</span>
      </div>
      <!-- PENDING -->
      <div
        *ngSwitchCase="APPLIANCE_CAPACITY_STATUS.UpdatesPending"
        class="pending-appliance-chip-label"
      >
        <span>{{ 'appliances.capacity.updatesPending' | t }}</span>
      </div>
      <!-- OVERSUBSCRIBED -->
      <div
        *ngSwitchCase="APPLIANCE_CAPACITY_STATUS.Oversubscribed"
        class="oversubscribed-appliance-health-label"
      >
        <span>{{ 'appliances.capacity.oversubscribed' | t }}</span>
      </div>
      <!-- RESOLVE -->
      <div
        *ngSwitchCase="APPLIANCE_CAPACITY_STATUS.Oversubscribed"
        class="oversubscribed-appliance-resolve-label"
        (click)="resolveCapacityStatus()"
      >
        <span>{{ 'appliances.actions.resolve' | t }}</span>
      </div>
      <!-- UNKNOWN -->
      <div *ngSwitchCase="APPLIANCE_CAPACITY_STATUS.Unknown" class="unknown-appliance-chip-label">
        <span>{{ 'appliances.capacity.unknown' | t }}</span>
      </div>
    </mat-chip>
  </mat-chip-list>
</ng-container>
